import { useMemo } from 'react';
import type { TimelineStudy } from '../types/studyTimeline';
import { groupByMonth } from '../utils/studyTimelineGrouping';
import { useStudyExpandState } from '../hooks/useStudyExpandState';
import { MonthGroup } from './MonthGroup';
import { StudyCard } from './StudyCard';
import styles from './StudyHistoryTimeline.module.css';

interface StudyHistoryTimelineProps {
  studies: TimelineStudy[];
  showReportHistory: boolean;
}

export default function StudyHistoryTimeline({
  studies,
  showReportHistory,
}: StudyHistoryTimelineProps) {
  const monthGroups = useMemo(() => groupByMonth(studies), [studies]);
  const { expandedMap, toggleStudy } = useStudyExpandState(
    studies,
    showReportHistory
  );

  // Compute global index for last-dot logic
  const totalStudies = studies.length;
  let globalIndex = 0;

  return (
    <div className={styles.timeline}>
      {monthGroups.map((group) => (
        <MonthGroup key={group.key} label={group.label}>
          {group.studies.map((study) => {
            const currentGlobalIndex = globalIndex;
            globalIndex += 1;
            const isLastGlobal = currentGlobalIndex === totalStudies - 1;

            return (
              <StudyCard
                key={study.uuid}
                study={study}
                isLastGlobal={isLastGlobal}
                expanded={expandedMap.get(study.uuid) ?? false}
                onToggle={toggleStudy}
              />
            );
          })}
        </MonthGroup>
      ))}
    </div>
  );
}
